import React from "react";

import { CgSpinner } from "react-icons/cg";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
}

export function Button({ children, loading, disabled, ...rest }: IProps) {
  return (
    <button {...rest} disabled={disabled || loading}>
      {loading ? <CgSpinner className="loading-icon" /> : null} {children}
    </button>
  );
}
